module.exports = __webpack_public_path__ + "img/judge1.828bc8fe.svg";